export default __webpack_public_path__ + "static/media/marketing.0958a3b9.jpg";